import { AfterViewInit, Component, Input, OnChanges } from '@angular/core';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { PlatformBrowserService } from '@app/core/services/platform-browser.service';
import { CheckBrowserChartService } from '@app/core/services/check-browser-chart.service';
import { Subject, combineLatest } from 'rxjs';

@Component({
    selector: 'app-column-chart-activity-system',
    templateUrl: './column-chart-activity-system.component.html',
    styleUrls: ['./column-chart-activity-system.component.scss']
})
export class ColumnChartActivitySystemComponent implements OnChanges, AfterViewInit {
    @Input() public rangeWeek: boolean = true;
    @Input() public data: any;
    @Input() public nameRoot: any;
    @Input() public changeSystem: boolean = false;
    private afterViewInitSubject: Subject<any> = new Subject();
    private onChangesSubject: Subject<any> = new Subject();
    private chart: any;
    private root!: am5.Root;

    public constructor(private browserService: PlatformBrowserService, private checkBrowserOnly: CheckBrowserChartService) {
        combineLatest([this.afterViewInitSubject, this.onChangesSubject]).subscribe(() => {
            this.checkBrowserOnly.browserOnly(() => {
                this.root.setThemes([am5themes_Animated.new(this.root)]);

                this.setChart();
                this.createSeries(this.rangeWeek ? 'Actividad de la semana' : 'Actividad del mes', 'value');
            });
        });
    }

    public ngAfterViewInit(): void {
        if (!this.browserService.isBrowser) {
            return;
        }
        this.root = am5.Root.new(this.nameRoot);
        this.afterViewInitSubject.next(true);
    }

    public ngOnChanges(): void {
        if (!this.browserService.isBrowser) {
            return;
        }

        if (this.data === undefined || this.data.length === 0) {
            return;
        }

        if (this.changeSystem) {
            this.chart.dispose();
        }

        this.onChangesSubject.next(true);
    }

    private setChart(): void {
        this.chart = this.root.container.children.push(
            am5xy.XYChart.new(this.root, {
                panY: false,
                layout: this.root.verticalLayout
            })
        );
    }

    private setXAxisWeekDay(): any {
        let xAxis: any = this.chart.xAxes.push(
            am5xy.CategoryAxis.new(this.root, {
                categoryField: 'category',
                renderer: am5xy.AxisRendererX.new(this.root, {})
            })
        );
        xAxis.data.setAll(this.data);

        return xAxis;
    }

    private setXAxisMonth(): any {
        let xAxis: any = this.chart.xAxes.push(
            am5xy.DateAxis.new(this.root, {
                baseInterval: {
                    timeUnit: 'day',
                    count: 1
                },
                min: this.setLimitMonth('min'),
                max: this.setLimitMonth('max'),
                renderer: am5xy.AxisRendererX.new(this.root, {})
            })
        );

        return xAxis;
    }

    private setYAxis(): any {
        let yAxis: any = this.chart.yAxes.push(
            am5xy.ValueAxis.new(this.root, {
                renderer: am5xy.AxisRendererY.new(this.root, {})
            })
        );

        return yAxis;
    }

    /*eslint-disable */
    public createSeries(name: string, field: string): void {
        let series: any = this.rangeWeek
            ? this.chart.series.push(
                  am5xy.ColumnSeries.new(this.root, {
                      name: name,
                      xAxis: this.setXAxisWeekDay(),
                      yAxis: this.setYAxis(),
                      valueYField: field,
                      categoryXField: 'category'
                  })
              )
            : this.chart.series.push(
                  am5xy.ColumnSeries.new(this.root, {
                      name: name,
                      xAxis: this.setXAxisMonth(),
                      yAxis: this.setYAxis(),
                      valueYField: field,
                      valueXField: 'date'
                  })
              );
        series.columns.template.setAll({
            fill: am5.color(0x00cc99),
            stroke: am5.color(0x00cc99)
        });
        series.data.setAll(this.data);
    }
    /*eslint-enable */

    public setLimitMonth(maxOrMin: string): any {
        let month: number = new Date().getMonth();
        let year: number = new Date().getFullYear();

        if (maxOrMin === 'min') {
            return new Date(year, month, new Date(year, month, 1).getDate());
        }

        return new Date(year, month, new Date(year, month, 0).getDate());
    }
}
